/*
 * Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
 *
 * This SOURCE CODE FILE, which has been provided by Certusoft as part
 * of a Certusoft product for use ONLY by licensed users of the product,
 * includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
 *
 * USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
 * OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
 * THE PRODUCT.
 */

import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Account } from '../../models/clikcrm/CRM'

@Injectable({
    providedIn: 'root',
})
export class ClikCRMService {
    constructor(private $http: HttpClient) {}

    getAccount(): Promise<Array<Account>> {
        let vm = this
        let promise = vm.$http
            .get('/api/clikcrm/account')
            .toPromise()
            .then(
                function (result: any) {
                    console.debug('Got Good response for getAccount' + JSON.stringify(result))
                    return result
                },
                function (result) {
                    console.error('Got Bad Result for getAccount', result)
                }
            )
        return promise
    }

    getAccountById(subjectId: string): Promise<Array<Account>> {
        let vm = this
        let promise = vm.$http
            .get('/api/clikcrm/account/' + subjectId)
            .toPromise()
            .then(
                function (result: any) {
                    console.debug('Got Good response for getAccount' + JSON.stringify(result))
                    return result
                },
                function (result) {
                    console.error('Got Bad Result for getAccount', result)
                }
            )
        return promise
    }
}
